module.exports = __webpack_public_path__ + "static/media/iconTickBlue.45f65968.svg";